import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { OrdenMenuService } from './orden-menu.service';

@Component({
  selector: 'app-orden-menu',
  templateUrl: './orden-menu.component.html',
  styleUrls: ['./orden-menu.component.scss']
})
export class OrdenMenuComponent implements OnInit {

  ordenForm ;
  constructor(private fb: FormBuilder,
              private orden_serv :OrdenMenuService) { }

  ngOnInit(): void {
    this.ordenForm = this.fb.group({
      num_orden: [null, Validators.pattern('^[1-9][0-9]*$')]  
    });
  }

  onSubmit(){
    this.orden_serv.num_orden = this.ordenForm.value.num_orden;
    this.orden_serv.dialogRef.close();
  }

}
